import {CLStore} from 'common/src/redux/store';
import loadCampaignToRedux from 'common/src/modules/campaigns/store/campaignTree/thunks/loadCampaignToRedux';

export async function reloadCampaign(store: CLStore) {
  const state = store.getState();
  const campaignId = state.campaignPage.campaignTree.campaign?.id;
  const versionNumber = state.campaignPage.campaignTree.versionNumber;

  if (!campaignId || !versionNumber) {
    throw new Error('Campaign not loaded in Redux state');
  }

  await store.dispatch(
    loadCampaignToRedux({campaignId, version: String(versionNumber)}),
  ).unwrap();
}
